import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

import { Box, Dialog } from '@redriverpress/system'

export const Content = styled(Dialog.Content)`
  background: ${props => props.theme.colors.white};
  position: fixed;
  inset: 0;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  z-index: 6;
`

export const GenreLink = styled(NavLink)`
  display: flex;
  align-items: flex-start;
  background: transparent;
  text-decoration: none;
  /* px & mx to create negative space for box shadow focus ring */
  padding: 0.5rem 0.5rem;
  margin: 0 -0.5rem;
  position: relative;

  &:hover {
    color: currentColor; /* override default link style */
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${props => props.theme.colors.blue500};
    border-radius: ${props => props.theme.radii.rounded};
  }

  &.active {
    font-weight: 600;
  }

  [data-active-genre-icon] {
    opacity: 0;
  }

  &.active [data-active-genre-icon] {
    opacity: 1;
  }
`

export const TitleBar = styled(Box).attrs({
  bg: 'gray100',
  display: 'flex',
  alignItems: 'center',
  py: 3,
  pl: 3,
  pr: 2,
  boxShadow: 2,
  position: 'fixed',
  top: '0',
  left: '0',
  right: '0',
  zIndex: '1',
})``
